define('plugin/membership/view/MembershipModuleListView',['require','lib/view/BaseCompositeView','plugin/membership/view/MembershipModuleItemView','lib/view/UnwrapBehavior'],function (require) {

    var Parent = require('lib/view/BaseCompositeView');
    var MembershipModuleItemView = require('plugin/membership/view/MembershipModuleItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Membership payment history view
     *
     * @class MembershipPaymentHistoryListView
     */
    return Parent.extend({

        template: '#membership_module_list_view',
        childView: MembershipModuleItemView,
        childViewContainer: '#sb_membership_module_list_container',
        childViewOptions: function (model, index) {
            return {
                serviceCollection: this.getOption('serviceCollection'),
            };
        },
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        collectionEvents: {
            'sync': 'render'
        },


        limit: 4,
        _ids: [],

        _moduleId: 'membership',

        initialize: function () {

        },

        filter: function (model) {
            if (_.indexOf(this._ids, model.get('id')) === -1) {
                return false;
            }
            return true;
        },

        onBeforeRender: function () {
            if (this.$el && this.$el.parent().length) {
                var count = this.$el.parent().data('sb-count');
                if (parseInt(count) && parseInt(count) != this.limit) {
                    this.limit = parseInt(count);
                }
            }

            this._ids = this.collection.pluck('id').slice(0, this.limit);
        }

    });

});
